"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HackerUIProvider = void 0;
var HackerUIProvider_1 = require("./HackerUIProvider");
Object.defineProperty(exports, "HackerUIProvider", { enumerable: true, get: function () { return HackerUIProvider_1.HackerUIProvider; } });
//# sourceMappingURL=index.js.map